import {Icon, IconButton} from '@wandb/components';
import React, {useCallback} from 'react';

import {AGENT_NAME} from './constants';
import {useNewChat} from './useNewChat';
import {useTrackWBAgentPanel} from './useTrackWBAgent';
import {useWBAgentContextStore} from './WBAgentContextStore';

export const WBAgentHeader = () => {
  const setOpen = useWBAgentContextStore(s => s.setOpen);
  const docked = useWBAgentContextStore(s => s.docked);
  const setDocked = useWBAgentContextStore(s => s.setDocked);
  const historySidebarOpen = useWBAgentContextStore(s => s.historySidebarOpen);
  const setHistorySidebarOpen = useWBAgentContextStore(
    s => s.setHistorySidebarOpen
  );
  const {trackDocked, trackUndocked, trackClosed} = useTrackWBAgentPanel();
  const handleNewChat = useNewChat();

  const handleToggleDocked = useCallback(() => {
    const next = !docked;
    setDocked(next);
    if (next) {
      trackDocked();
    } else {
      trackUndocked();
    }
  }, [docked, setDocked, trackDocked, trackUndocked]);

  const handleClose = useCallback(() => {
    setOpen(false);
    trackClosed();
  }, [setOpen, trackClosed]);

  return (
    <div className="flex items-center justify-between border-b border-solid border-moon-250 px-16 py-12">
      <div className="flex items-center gap-8">
        <IconButton
          variant="ghost"
          icon="menu"
          aria-label="history"
          isActive={historySidebarOpen}
          onClick={() => {
            setHistorySidebarOpen(!historySidebarOpen);
          }}
          tooltip={{children: 'Chat history'}}
        />
        <Icon
          aria-label="workspace-agent-logo"
          icon="lightboard-solid"
          color="teal-550"
        />
        <h2
          className="text-xl font-semibold tracking-wide"
          style={{letterSpacing: '1.6px'}}>
          {AGENT_NAME}
        </h2>
      </div>
      <div>
        <IconButton
          variant="ghost"
          icon="compose"
          aria-label="new-chat"
          onClick={handleNewChat}
          tooltip={{
            children: 'Start new chat (clears current)',
          }}
        />
        <IconButton
          variant="ghost"
          icon={docked ? 'undock' : 'dock-arrow'} // To do: switch to dock-arrow and undock when core-ux PR is approved
          aria-label={docked ? 'undock chat' : 'dock chat'}
          onClick={handleToggleDocked}
          tooltip={{
            children: docked ? 'Undock chat' : 'Dock chat',
          }}
        />
        <IconButton
          variant="ghost"
          icon="remove"
          aria-label="minimize"
          onClick={handleClose}
          tooltip={{
            children: 'Minimize',
          }}
        />
      </div>
    </div>
  );
};
